import React, { type ReactNode } from 'react'
import { twMerge } from 'tailwind-merge'

import { HStack } from '../hstack'

export type NavTabSlotProps = {
    children: ReactNode
    className?: string
}

// Figma "NavTabSlot" (node 9534:124501): an 84px-min centred slot for a nav-bar
// control. No divider: design dropped dividers between nav-bar filters (AOS-1354).
export function NavTabSlot({ children, className }: NavTabSlotProps) {
    return (
        <HStack
            className={twMerge(
                'min-w-[84px] h-full flex-row items-center justify-center px-4',
                className,
            )}
        >
            {children}
        </HStack>
    )
}
